/**
 * 使用ページ確認インプット用VOクラス
 *
 * @export KYMW0E00InputModel
 * @class KYMW0E00InputModel
 */
export class KYMW0E00InputModel {

  /** 画面ID */
  public formID: string = <string>'';

  /** 処理区分 */
  public processDiv = Number(0);

  /** 画像ID */
  public imageID: string = <string>'';

  /** 画像名 */
  public imageName: string = <string>'';

  /** 画像ファイル名 */
  public imageFileName: string = <string>'';

  /** 変更前　使用開始受注コード */
  public startOrderCodeBefore: string = <string>'';

  /** 変更前　使用終了受注コード */
  public endOrderCodeBefore: string = <string>'';

  /** 変更後　使用開始受注コード */
  public startOrderCodeAfter: string = <string>'';

  /** 変更後　使用終了受注コード */
  public endOrderCodeAfter: string = <string>'';

  /**
   * コンストラクタ
   */
  constructor() { }
}
